<template>
  <div id="" class="">
      <el-dialog :title="dTitle" :visible.sync="isShowDialog" :before-close="beforeClose" width="80%" top="2%">

        <common-search :searchList="searchList" @onSearch="onSearch"></common-search>
        <common-table 
          :machineList="machineList" 
          :loading="loading" 
          @sort-change="sortChange" 
          @data-change="getMessageByPage"
          :storageName="storageName"
          title="广东省特种设备检测研究院惠州检测院设备台账表"
          :type="tableType"
          height="650"
          :tableHandler="tableHandler"
          ></common-table>
        <div style="text-align: right;margin-top:10px">
           <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import EquipmentTableComponent from "@/components/instrument/EquipmentTableComponent.vue";
import SearchComponent from "@/components/instrument/SearchComponent.vue";
export default {
  components: {
    'common-table': EquipmentTableComponent,
    'common-search': SearchComponent
  },
  props:['dialogVisible','alertType','dTitle'],
  watch: {
    dialogVisible(val){
      this.isShowDialog = val;
      if(val){
        this.currentPage=1;
        this.getMessageByPage();
      }
    },
    alertType(val){
      if(val){
        this.currentPage=1;
        this.alertType = val;
        if(val === 'overBorrow'){
          this.tableType = "over";
          this.tableHandler = [
            'tip'
          ]
          this.storageName = 'checkedHeaders_over_borrow'
        }
        else{
          this.tableType = "machines";
          this.tableHandler = [
            'show','deal'
          ];
          this.storageName = 'checkedHeaders_over'
        }
      }
    }
  },
  data() {
    return {
      isShowDialog: false,
      verificationDialogVisible: false,
      loading: false,
      machineList: null,
      machineNO: '',
      name: '',
      verificationValidDate:[],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 10,
      machine: {},
      equipmentDialogVisible: false,
      dialogTitle: '',
      searchList: {
        newMachineNO: '',name: '',
      },
      tableHandler: [
        'show','deal'
      ],
      tableType: 'machines',
      storageName: 'checkedHeaders_over'
    }
  },
  methods:{
    sortChange(val){
      console.log(val)
      this.order = val.order;
      this.getMessageByPage();
    },
    onSearch(){
      this.$commondata.searchObj = this.searchList;
      this.getMessageByPage();
    },
    changeDialogState(val){
      this.verificationDialogVisible = val;
    },
    changeMachine(){
      this.getMessageByPage();
    },

    beforeClose(done){
      this.isShowDialog = false;
      //this.$refs.record_table.setCurrentRow();
      this.$emit('change-state',{isShow: this.isShowDialog,dialog:'operation'});
    },

    async getMessageByPage(cb){
      this.loading = true;
      let options = this.$util.formatOptions(this.searchList);
      let requestType = 'machines';

      let now_date = this.$util.formatDate(new Date().getTime());
      if(this.alertType === 'verifyAlert'){
        if(this.$util.isEmpty(this.order))
          this.order = "verificationValidDate desc";
        let late_date = this.$util.formatDate(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
        options['verificationValidDate'] = [now_date,late_date];
      }else if(this.alertType === 'verifyOverAlert'){
        if(this.$util.isEmpty(this.order))
          this.order = "verificationValidDate desc";
        options['verificationValidDate'] = ['1970-01-01',now_date];
      }else if(this.alertType === 'overBorrow'){
        requestType = 'operation';
        if(this.$util.isEmpty(this.order))
          this.order = "default";
        let late_date = this.$util.formatDate(new Date().getTime() - 1 * 24 * 60 * 60 * 1000);
        options['borrowTime'] = ['1970-01-01 00:00:01',late_date + " 23:59:59"],
        options['returnTime'] = "";
        options['status'] = '借出';
      }
      //options['status'] = '在用';

      let _machineList = await this.$equipmentdata.getMessageByPage(requestType,this.currentPage,this.pageSize,JSON.stringify(options),this.order);
      this.machineList = _machineList.result;
      this.total = _machineList.total
      
      cb && cb(_machineList.total)

      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },

    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

  },
}
</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/dialog/OperationDialog.vue